"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TenantConcurConnect = void 0;
var connect_1 = require("./concur/connect");
Object.defineProperty(exports, "TenantConcurConnect", { enumerable: true, get: function () { return connect_1.Connect; } });
